<template>
	<common-welcomebox
		card-type="dismiss"
		:title="greeting"
		:hide-button="true"
		subtitle=" "
		:video-src="videoSrc"
		@dismiss="dismiss({ key: upsellKey })"
	>
		<slot></slot>
		<core-button :arrow="true" size="monster" color="green" :href="url" target="_blank" rel="noopener">
			UNLOCK {{ planName }} NOW!
		</core-button>
	</common-welcomebox>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

export default {
	props: {
		videoSrc: {
			type: String,
			default: '',
		},
		upsellKey: {
			type: String,
			default: '',
		},
	},
	computed: {
		...mapGetters(['userFirstName', 'proUpsellPlan']),
		greeting() {
			let name = '';
			if (this.userFirstName) {
				name += ', ' + this.userFirstName;
			}

			return `Ready for more power${name}?`;
		},
		url() {
			return this.$urls.upgrade({
				utm_medium: `Dashboard${this.upsellKey}Box`,
				feature: 'none',
			});
		},
		planName() {
			return this.proUpsellPlan.toUpperCase();
		},
	},
	methods: {
		...mapMutations('dashboard', ['dismiss']),
	},
};
</script>
